import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ccb53a3&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccb53a3')) {
      api.createRecord('4ccb53a3', component.options)
    } else {
      api.reload('4ccb53a3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ccb53a3&", function () {
      api.rerender('4ccb53a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwInputNumber/index.vue"
export default component.exports